import { useComplaintReasonsQuery } from '../queries';

export default function useComplaintReasons(open: boolean) {
  const { data = [], isLoading, error } = useComplaintReasonsQuery(open);
  return { data, loading: isLoading, error };
}
